import React from 'react';
import { TableRow, TableCell, FormControlLabel, Checkbox, IconButton } from '@mui/material';
import { Refresh } from '@mui/icons-material';
import { TimePersonSelector } from '../common/time_person_selector';
import { CheckboxCell, ArrowCell } from '../../../style/tablecell';
import { COMMON_RESET_FIELDS } from '../../../const/suiro_fields';
import { getCellBgColor } from '../../../func/util';

export const RequiredCommonRow = ({
  headerHeight,
  lefts,
  suiroExtractList,
  users,
  setOtherSuiroExtractList,
  clearAllRows,
  handleCheckboxChange,
  handleRowTimeChange,
  handleRowSelectChange
}) => {
  const commonCellStyle = {
    py: 0.5,
    position: 'sticky',
    top: headerHeight,
    zIndex: 900,
    backgroundColor: '#ffffff',
    borderBottom: '1px solid rgba(224,224,224,1)'
  };

  const firstRow = suiroExtractList && suiroExtractList.length ? suiroExtractList[0] : {};

  return (
    <TableRow
      key="all-common"
      sx={{
        backgroundColor: 'inherit',
        alignItems: 'center',
        height: 90,
        '& .MuiTableCell-root': { height: 90 }
      }}
    >
      {/* 固定列 */}
      <TableCell
        sx={{
          width: 65,
          minWidth: 65,
          position: 'sticky',
          left: `${lefts.reset}px`,
          top: headerHeight,
          zIndex: 1000,
          backgroundColor: 'background.paper',
          borderBottom: '1px solid rgba(224,224,224,1)'
        }}
      >
        <IconButton
          size="small"
          title="全発電所の値をすべてクリア"
          sx={{ p: 0.5 }}
          onClick={() => {
            clearAllRows(false);
          }}
        >
          <Refresh fontSize="small" />
        </IconButton>
      </TableCell>
      <TableCell
        align="center"
        sx={{
          width: 90,
          minWidth: 80,
          position: 'sticky',
          left: `${lefts.notReport}px`,
          top: headerHeight,
          zIndex: 1000,
          backgroundColor: 'background.paper',
          borderBottom: '1px solid rgba(224,224,224,1)'
        }}
      >
        発電所共通
      </TableCell>

      <TableCell
        sx={{ 
          minWidth: 120,
          position: 'sticky',
          left: `${lefts.name}px`,
          top: headerHeight,
          zIndex: 1000,
          backgroundColor: 'background.paper',
          borderBottom: '1px solid rgba(224,224,224,1)',
          borderRight: '1px solid rgba(224,224,224,1)',
          textAlign: 'left',
          pl: 0
        }}
      />

      {/* 地震発生日時 */}
      <TableCell sx={commonCellStyle} />

      {/* 各発電所運転状況確認 */}
      <TableCell sx={{ ...commonCellStyle, minWidth: 180, px: 1, backgroundColor: getCellBgColor(!!(firstRow.initial_response_at && firstRow.initial_response_person), false, false) }}>
        <TimePersonSelector
          timeValue={firstRow.initial_response_at}
          personValue={firstRow.initial_response_person}
          onTimeChange={(newVal) => {
            handleRowTimeChange(firstRow.uuid, 'initial_response_at', newVal, true)
          }}
          onPersonChange={(e) => {
            const v = e.target.value;
            handleRowSelectChange(firstRow.uuid, 'initial_response_person', v, true);
          }}
          users={users}
          personLabel="担当者"
        />
      </TableCell>

      <ArrowCell sx={commonCellStyle} />

      {/* 水路抜水発電所を決定 */}
      <TableCell sx={commonCellStyle} />

      <ArrowCell sx={commonCellStyle} />

      {/* 取水停止・水路抜水発電所を電気グループへ共有 */}
      <CheckboxCell sx={{...commonCellStyle, backgroundColor: getCellBgColor(!!firstRow.is_notified_to_electric_group, false, false)}}>
        <FormControlLabel 
          control={
            <Checkbox
              checked={!!firstRow.is_notified_to_electric_group}
              onChange={() => {
                const newVal = !firstRow.is_notified_to_electric_group;
                handleCheckboxChange(firstRow.uuid, 'is_notified_to_electric_group', true);
              }}
              size="small" 
            />
          } 
          label="" 
        />
      </CheckboxCell>

      <ArrowCell sx={commonCellStyle} />

      {/* 灌漑利水者へ連絡 */}
      <TableCell sx={{ ...commonCellStyle, minWidth: 180, px: 1, backgroundColor: getCellBgColor(!!(firstRow.notified_irrigation_users_at1 && firstRow.notified_irrigation_users_person1), false, false) }}>
        <TimePersonSelector
          timeValue={firstRow.notified_irrigation_users_at1}
          personValue={firstRow.notified_irrigation_users_person1}
          onTimeChange={(newVal) => {
            handleRowTimeChange(firstRow.uuid, 'notified_irrigation_users_at1', newVal, true)
          }}
          onPersonChange={(e) => {
            const v = e.target.value;
            handleRowSelectChange(firstRow.uuid, 'notified_irrigation_users_person1', v, true);
          }}
          users={users}
          personLabel="担当者"
        />
      </TableCell>

      <ArrowCell sx={commonCellStyle} />

      {/* 取水停止(遠隔操作有)の実施 */}
      <CheckboxCell sx={{...commonCellStyle, backgroundColor: getCellBgColor(!!firstRow.is_powerplant_operation_checked, false, false)}}>
        <FormControlLabel
          control={
            <Checkbox
              checked={!!firstRow.is_powerplant_operation_checked}
              onChange={() => {
                const newVal = !firstRow.is_powerplant_operation_checked;
                handleCheckboxChange(firstRow.uuid, 'is_powerplant_operation_checked', true);
              }}
              size="small"
            />
          }
          label=""
        />
      </CheckboxCell>

      <ArrowCell sx={commonCellStyle} />

      {/* 取水停止連絡 */}
      <TableCell sx={commonCellStyle} />

      <ArrowCell sx={commonCellStyle} />

      {/* 取水停止完了 */}
      <TableCell sx={commonCellStyle} />

      <ArrowCell sx={commonCellStyle} />

      {/* ニシコーとの情報共有 */}
      <CheckboxCell sx={{...commonCellStyle, backgroundColor: getCellBgColor(!!firstRow.is_intake_stop_completed_share_with_nishiko, false, false)}}>
        <FormControlLabel
          control={
            <Checkbox
              checked={!!firstRow.is_intake_stop_completed_share_with_nishiko}
              onChange={() => {
                const newVal = !firstRow.is_intake_stop_completed_share_with_nishiko;
                handleCheckboxChange(firstRow.uuid, 'is_intake_stop_completed_share_with_nishiko', true);
              }}
              size="small"
            />
          }
          label=""
        />
      </CheckboxCell>

      <ArrowCell sx={commonCellStyle} />

      {/* 水力中給に情報共有 */}
      <TableCell sx={{ ...commonCellStyle, minWidth: 180, px: 1, backgroundColor: getCellBgColor(!!(firstRow.intake_stop_completed_shared_with_hydropower_center_at && firstRow.intake_stop_completed_shared_with_hydropower_center_person), false, false) }}>
        <TimePersonSelector
          timeValue={firstRow.intake_stop_completed_shared_with_hydropower_center_at}
          personValue={firstRow.intake_stop_completed_shared_with_hydropower_center_person}
          onTimeChange={(newVal) => {
            handleRowTimeChange(firstRow.uuid, 'intake_stop_completed_shared_with_hydropower_center_at', newVal, true)
          }}
          onPersonChange={(e) => {
            const v = e.target.value;
            handleRowSelectChange(firstRow.uuid, 'intake_stop_completed_shared_with_hydropower_center_person', v, true);
          }}
          users={users}
          personLabel="担当者"
        />
      </TableCell>

      <ArrowCell sx={commonCellStyle} />

      {/* 安全確認後水路抜水 */}
      <CheckboxCell sx={{...commonCellStyle, backgroundColor: getCellBgColor(!!firstRow.is_drainage_after_safety_check, false, false)}}>
        <FormControlLabel
          control={
            <Checkbox
              checked={!!firstRow.is_drainage_after_safety_check}
              onChange={() => {
                const newVal = !firstRow.is_drainage_after_safety_check;
                handleCheckboxChange(firstRow.uuid, 'is_drainage_after_safety_check', true);
              }}
              size="small"
            />
          }
          label=""
        />
      </CheckboxCell>

      <ArrowCell sx={commonCellStyle} />

      {/* 水路抜水連絡 */}
      <TableCell sx={commonCellStyle} />

      <ArrowCell sx={commonCellStyle} />

      {/* 水路抜水完了 */}
      <TableCell sx={commonCellStyle} />

      <ArrowCell sx={commonCellStyle} />

      {/* ニシコーとの情報共有(2回目) */}
      <CheckboxCell sx={{...commonCellStyle, backgroundColor: getCellBgColor(!!firstRow.is_drainage_completed_share_with_nishiko, false, false)}}>
        <FormControlLabel
          control={
            <Checkbox
              checked={!!firstRow.is_drainage_completed_share_with_nishiko}
              onChange={() => {
                const newVal = !firstRow.is_drainage_completed_share_with_nishiko;
                handleCheckboxChange(firstRow.uuid, 'is_drainage_completed_share_with_nishiko', true);
              }}
              size="small"
            />
          }
          label=""
        />
      </CheckboxCell>

      <ArrowCell sx={commonCellStyle} />

      {/* 空セル */}
      {Array.from({ length: 9 }).map((_, i) => (
        <React.Fragment key={i}>
          <TableCell sx={commonCellStyle} />
          {i < 9 && <ArrowCell sx={commonCellStyle} />}
        </React.Fragment>
      ))}

      {/* 灌漑利水者へ連絡（2回目） */}
      <TableCell sx={{ ...commonCellStyle, minWidth: 180, px: 1, backgroundColor: getCellBgColor(!!(firstRow.notified_irrigation_users_at2 && firstRow.notified_irrigation_users_person2), false, false) }}>
        <TimePersonSelector
          timeValue={firstRow.notified_irrigation_users_at2}
          personValue={firstRow.notified_irrigation_users_person2}
          onTimeChange={(newVal) => {
            const formatted = newVal ? newVal.format('HH:mm') : '';
            handleRowTimeChange(firstRow.uuid, 'notified_irrigation_users_at2', newVal, true)
          }}
          onPersonChange={(e) => {
            const v = e.target.value;
            handleRowSelectChange(firstRow.uuid, 'notified_irrigation_users_person2', v, true);
          }}
          users={users}
          personLabel="担当者"
        />
      </TableCell>

      <ArrowCell sx={commonCellStyle} />

      {/* 水力中給に情報共有（2回目） */}
      <TableCell sx={{ ...commonCellStyle, minWidth: 180, px: 1, backgroundColor: getCellBgColor(!!(firstRow.shared_with_hydropower_center_at2 && firstRow.shared_with_hydropower_center_person2), false, false) }}>
        <TimePersonSelector
          timeValue={firstRow.shared_with_hydropower_center_at2}
          personValue={firstRow.shared_with_hydropower_center_person2}
          onTimeChange={(newVal) => {
            const formatted = newVal ? newVal.format('HH:mm') : '';
            handleRowTimeChange(firstRow.uuid, 'shared_with_hydropower_center_at2', newVal, true)
          }}
          onPersonChange={(e) => {
            const v = e.target.value;
            handleRowSelectChange(firstRow.uuid, 'shared_with_hydropower_center_person2', v, true);
          }}
          users={users}
          personLabel="担当者"
        />
      </TableCell>

      <ArrowCell sx={commonCellStyle} />

      {/* 空セル */}
      {Array.from({ length: 4 }).map((_, i) => (
        <React.Fragment key={i}>
          <TableCell sx={commonCellStyle} />
          {i < 4 && <ArrowCell sx={commonCellStyle} />}
        </React.Fragment>
      ))}

      {/* 灌漑利水者へ連絡（3回目） */}
      <TableCell sx={{ ...commonCellStyle, minWidth: 180, px: 1, backgroundColor: getCellBgColor(!!(firstRow.notified_irrigation_users_at3 && firstRow.notified_irrigation_users_person3), false, false) }}>
        <TimePersonSelector
          timeValue={firstRow.notified_irrigation_users_at3}
          personValue={firstRow.notified_irrigation_users_person3}
          onTimeChange={(newVal) => {
            handleRowTimeChange(firstRow.uuid, 'notified_irrigation_users_at3', newVal, true)
          }}
          onPersonChange={(e) => {
            const v = e.target.value;
            handleRowSelectChange(firstRow.uuid, 'notified_irrigation_users_person3', v, true);
          }}
          users={users}
          personLabel="担当者"
        />
      </TableCell>

      <ArrowCell sx={commonCellStyle} />

      {/* 完了 */}
      <TableCell sx={commonCellStyle} />

    </TableRow>
  );
};